import * as i0 from "@angular/core";
var PostalCodeUtilsService = /** @class */ (function () {
    function PostalCodeUtilsService() {
        this.postalCodeRegex = /^[0-9]{5}(-)?([0-9]{3})?$/;
    }
    PostalCodeUtilsService.prototype.isValidFormat = function (postalCode) {
        return this.postalCodeRegex.test(postalCode);
    };
    PostalCodeUtilsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PostalCodeUtilsService_Factory() { return new PostalCodeUtilsService(); }, token: PostalCodeUtilsService, providedIn: "root" });
    return PostalCodeUtilsService;
}());
export { PostalCodeUtilsService };
